import { DateUtil } from "../../base/util/DateUtil";
import isBlank from "@sedan-utils/is-blank";
export class CurrentPlan {
    constructor() {
        this.itemId = "";
        this.name = "";
        this.value = "";
        this.isCancel = false;
        this.expiryDate = "";
        this.price = {
            amount: "",
            interval: "",
            interval_count: 0,
        };
    }
}
export class PayWallUtil {
    static async currentPlan(preferencesStore, brainClient, webFeature) {
        const subscriptionId = await preferencesStore.getByKey(PayWallUtil.subscription_id_key);
        if (typeof subscriptionId === "string" && !isBlank(subscriptionId)) {
            const subscriptions = await brainClient.payWall.subscription(subscriptionId);
            const subscription = subscriptions.data.items?.data[0];
            if (subscription) {
                const targetPlan = await brainClient.payWall
                    .plans()
                    .then(res => res.data.find(plan => plan.id === subscription.price.product));
                if (targetPlan) {
                    const currentPlan = new CurrentPlan();
                    currentPlan.subscriptionId = subscriptionId;
                    currentPlan.itemId = subscription.id;
                    currentPlan.name = targetPlan.metadata.name;
                    currentPlan.value = targetPlan.metadata.value;
                    currentPlan.customer = subscriptions.data?.customer;
                    currentPlan.isCancel = subscriptions.data.cancel_at_period_end;
                    currentPlan.price = {
                        amount: subscription.price.unit_amount_decimal,
                        interval: subscription.price.recurring.interval,
                        interval_count: subscription.price.recurring.interval_count,
                    };
                    if (subscriptions.data.cancel_at && !isBlank(subscriptions.data.cancel_at)) {
                        currentPlan.expiryDate = DateUtil.formatDate(subscriptions.data.cancel_at * 1000);
                    }
                    return currentPlan;
                }
            }
        }
        const currentPlan = new CurrentPlan();
        const freePlan = webFeature.find(plan => plan.free);
        if (freePlan && !isBlank(freePlan)) {
            currentPlan.name = freePlan.name.text || "";
            currentPlan.value = freePlan.value;
        }
        return currentPlan;
    }
}
PayWallUtil.subscription_id_key = "imagica_creator_premium_subscription_id";
